import { Label, TextInput, ErrorMessage } from "@trussworks/react-uswds";
import { useTranslation } from "react-i18next";

type ZipInputProps = {
  zip: string | undefined;
  setZip: (zip: string) => void;
  setDistanceSearchZipCode: (zip: string) => void;
  className?: string;
  placeholder?: string;
  autoFocus?: boolean;
  showError?: boolean;
  noLabel?: boolean;
};


function ZipInput({
  zip,
  setZip,
  setDistanceSearchZipCode,
  className,
  placeholder = undefined,
  noLabel = false,
  // eslint-disable-next-line unused-imports/no-unused-vars
  autoFocus = false,
  showError = false,
}: ZipInputProps) {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <Label htmlFor="zip" className="margin-bottom-1" srOnly={noLabel}>
        {t("locationTitle")}
      </Label>
      <div className="display-flex">
        <TextInput style={{border: "1px solid #1A103F", height: "50px"}}
          className={`margin-top-0 width-full ${
            showError ? "border-2px border-secondary-dark" : ""
          }`}
          id="zip"
          name="zip"
          type="text"
          inputMode="numeric"
          maxLength={5}
          value={zip}
          placeholder={placeholder}
          onChange={(evt) => {
            const cleanZipVal = evt.target.value.replace(/[^0-9]+/g, "");
            setZip(cleanZipVal);
            setDistanceSearchZipCode(cleanZipVal);
          }}
        />
      </div>
      {showError && <ErrorMessage>{t("invalidZipcodeError")}</ErrorMessage>}
    </div>
  );
}

export default ZipInput;
